var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBLBASEINFO" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          !_vm.popupParam.isApprContent
                            ? _c("c-appr-btn", {
                                ref: "appr-btn",
                                attrs: {
                                  name: "work-permit-appr-btn",
                                  editable: _vm.editable,
                                  approvalInfo: _vm.approvalInfo,
                                },
                                on: {
                                  beforeApprAction: _vm.approvalComEval,
                                  callbackApprAction:
                                    _vm.approvalComEvalCallback,
                                  requestAfterAction: _vm.getDetail,
                                },
                              })
                            : _vm._e(),
                          _vm.inputEditable &&
                          !_vm.disabled &&
                          _vm.isOld &&
                          !_vm.popupParam.isApprContent
                            ? _c("c-btn", {
                                attrs: { label: "LBLREMOVE", icon: "remove" },
                                on: { btnClicked: _vm.deleteData },
                              })
                            : _vm._e(),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.inputEditable && !_vm.disabled,
                                expression: "inputEditable && !disabled",
                              },
                            ],
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.evalTable,
                              mappingType: _vm.mappingType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveData,
                              btnCallback: _vm.saveCallback,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-3 col-sm-2 col-md-1 col-lg-1" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: false,
                            label: "LBL0010067",
                            name: "saiComplianceEvalTableId",
                          },
                          model: {
                            value: _vm.evalTable.saiComplianceEvalTableId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.evalTable,
                                "saiComplianceEvalTableId",
                                $$v
                              )
                            },
                            expression: "evalTable.saiComplianceEvalTableId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-2 col-lg-2" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            range: true,
                            disabled: _vm.disabled,
                            editable: _vm.inputEditable,
                            label: "LBL0010052",
                            name: "evalDts",
                          },
                          model: {
                            value: _vm.evalTable.evalDts,
                            callback: function ($$v) {
                              _vm.$set(_vm.evalTable, "evalDts", $$v)
                            },
                            expression: "evalTable.evalDts",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            editable: _vm.inputEditable,
                            label: "준수평가 제목",
                            name: "requirementName",
                          },
                          model: {
                            value: _vm.evalTable.requirementName,
                            callback: function ($$v) {
                              _vm.$set(_vm.evalTable, "requirementName", $$v)
                            },
                            expression: "evalTable.requirementName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-2 col-lg-2" },
                      [
                        _c("c-field", {
                          attrs: {
                            editable: _vm.inputEditable,
                            disabled: _vm.disabled,
                            label: "LBLREVIEWER",
                            name: "reviewUserId",
                          },
                          model: {
                            value: _vm.evalTable.reviewUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.evalTable, "reviewUserId", $$v)
                            },
                            expression: "evalTable.reviewUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-2 col-lg-2" },
                      [
                        _c("c-field", {
                          attrs: {
                            editable: _vm.inputEditable,
                            disabled: _vm.disabled,
                            label: "LBLAPPROVER",
                            name: "approvalUserId",
                          },
                          model: {
                            value: _vm.evalTable.approvalUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.evalTable, "approvalUserId", $$v)
                            },
                            expression: "evalTable.approvalUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-6 col-sm-4 col-md-1 col-lg-1" },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: true,
                            editable: _vm.inputEditable,
                            disabled: _vm.disabled,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.evalTable.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.evalTable, "plantCd", $$v)
                            },
                            expression: "evalTable.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "c-table",
        {
          ref: "table",
          staticClass: "q-mt-sm",
          attrs: {
            title: "LBL0010068",
            columns: _vm.grid.columns,
            data: _vm.gridData,
            gridHeight: _vm.gridHeight,
            merge: _vm.grid.merge,
            editable: _vm.inputEditable && !_vm.disabled,
            filtering: false,
            isFullScreen: false,
            columnSetting: false,
            selection: "multiple",
            rowKey: "saiComplianceEvalTableResultId",
          },
          scopedSlots: _vm._u(
            [
              !_vm.isRevision
                ? {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        col.name === "lawName"
                          ? [
                              _vm._v(" " + _vm._s(props.row[col.name]) + " "),
                              props.row.lawRecentInfo
                                ? _c(
                                    "q-badge",
                                    { attrs: { align: "top", color: "red" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row.lawRecentInfo) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : col.name === "customCol"
                          ? [
                              _c(_vm.imprComponent, {
                                tag: "component",
                                attrs: {
                                  col: col,
                                  props: props,
                                  inputEditable:
                                    _vm.inputEditable && !_vm.disabled,
                                  isImmShow: true,
                                  requestContentsCols: _vm.requestContentsCols,
                                  tableKey: "saiComplianceEvalTableResultId",
                                  ibmTaskTypeCd: "ITT0000160",
                                  ibmTaskUnderTypeCd: "ITTU000170",
                                },
                                on: { imprChange: _vm.imprChange },
                              }),
                            ]
                          : _vm._e(),
                      ]
                    },
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.inputEditable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: { label: "LBLEXCEPT", icon: "remove" },
                        on: { btnClicked: _vm.deleteTable },
                      })
                    : _vm._e(),
                  _vm.inputEditable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: { label: "LBLADD", icon: "add" },
                        on: { btnClicked: _vm.addTable },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "table-chip" },
            _vm._l(_vm.evalTable.compliancesTypes, function (lawType, idx) {
              return _c(
                "q-chip",
                {
                  key: idx,
                  attrs: {
                    outline: "",
                    square: "",
                    removable: false,
                    color: lawType.selected
                      ? lawType.lawId == "ALL"
                        ? "orange"
                        : "primary"
                      : "grey-6",
                    "text-color": "white",
                    icon: "memory",
                    selected: lawType.selected,
                    label: lawType.lawName,
                  },
                  on: {
                    "update:selected": [
                      function ($event) {
                        return _vm.$set(lawType, "selected", $event)
                      },
                      (state) => _vm.selectedEvalLaw(state, lawType, idx),
                    ],
                  },
                  model: {
                    value: lawType.check,
                    callback: function ($$v) {
                      _vm.$set(lawType, "check", $$v)
                    },
                    expression: "lawType.check",
                  },
                },
                [_c("q-tooltip", [_vm._v(_vm._s(lawType.lawName))])],
                1
              )
            }),
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }